import { signInUrl } from "@/common/utils/env";
import { Button } from "@rg/ui/components/Button";
import RGLiteLogo from "@/pages/lite-home-page/components/HomePage/images/rg-lite.svg?react";
import "./LiteHeader.scss";

export const LiteHeader = () => {
  const handleLogin = () => {
    window.location.href = typeof signInUrl === "string" ? signInUrl : "/";
  };

  return (
    <div className="LiteHeader">
      <RGLiteLogo className="LiteHeader-Logo" />
      <div className="LiteHeader-Info">
        <p className="LiteHeader-Text">Already a Verified Creator?</p>
        <Button size="lg" onClick={handleLogin}>Log In</Button>
      </div>
    </div>
  );
};
